import React, { Fragment, useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import { DatePicker, KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { withStyles } from "@material-ui/core/styles";
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import ModalUI from '../../../../../shared/components/Modal';


const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});

const no_op = () => { };
const FormAddAlergie = ({ id_historia, alergieToForm, setOpenModalFormAddAlergie = no_op, dropAlergieFormTexfield = no_op, editAlergie = false, setEditAlergie = no_op, getPatientAlergies = no_op }) => {
    const [nameAlergie, setNameAlergie] = useState(alergieToForm.nombre);
    const [isValid, setIsValid] = useState(false);
    const [isRemovable, setIsRemovable] = useState(false);
    const [isUsed, setIsUsed] = useState(false);
    const [severity, setSeverity] = useState(0);
    const [reaction, setReaction] = useState('');
    const [alergieDate, setAlergieDate] = useState(null);
    const [level, setLevel] = useState(0);
    const [comment, setComment] = useState('');

    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });
    const [errors, setErrors] = useState({});

    useEffect(() => {
      if(editAlergie && alergieToForm !== undefined && alergieToForm !== null){
        setSeverity(alergieToForm.severidad);
        setReaction(alergieToForm.reaccion);
        setAlergieDate(alergieToForm.fecha);
        setLevel(alergieToForm.etapa);
        setComment(alergieToForm.comentario);
      }
    }, [])
    

    const saveAlergie = async () => {
        let data = {
            nombre: nameAlergie,
            alergia_vigente: isValid,
            es_removible: isRemovable,
            es_uso: isUsed,
            severidad: severity,
            reaccion: reaction,
            fecha: alergieDate,
            etapa: level,
            comentario: comment,
            id_historia: id_historia
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.text();
            }
            else {
                throw new Error("Error guardando la alergia");
            }
        }).then((data) => {
            console.log("DATARESPONSE", data);
            setOpenAlert(true);
            setModalAlert({
                message: "Guardado con exito",
                color: 'success',
                title: "Exitoso!"
            });
            setOpenModalFormAddAlergie(false);
            getPatientAlergies();
        }).catch(err => {
            console.log(err);
        });
    }

    const EditAlergie = async (id_alergia) => {
        let data = {
            id_alergia: id_alergia,
            nombre: nameAlergie,
            alergia_vigente: isValid,
            es_removible: isRemovable,
            es_uso: isUsed,
            severidad: severity,
            reaccion: reaction,
            fecha: alergieDate,
            etapa: level,
            comentario: comment,
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.text();
            }
            else {
                throw new Error("Error guardando la alergia");
            }
        }).then((data) => {
            console.log("DATARESPONSE", data);
            setOpenAlert(true);
            setModalAlert({
                message: "Actualizado con exito",
                color: 'success',
                title: "Exitoso!"
            });
            setOpenModalFormAddAlergie(false);
            setEditAlergie(false)
            getPatientAlergies();
        }).catch(err => {
            console.log(err);
        });
    }

    const onToggleToClose = () => {
        if(editAlergie){
            setOpenModalFormAddAlergie(false);
            setEditAlergie(false)
        }else {
            setOpenModalFormAddAlergie(false);
            dropAlergieFormTexfield(alergieToForm);
        }
    }

    const handlerCheckIsValid = (check) => {
        setIsValid(check)
    }

    return (
        <Fragment>
            <div className='form-add-new-alergie'>
                <Row>
                    <div className='top-info-add-alergie'>
                        {
                            editAlergie ?
                                <div>
                                    <h4>Editar Alergia:</h4>
                                    <h4><b>{nameAlergie.toUpperCase()}</b></h4>
                                </div>
                                :
                                <div>
                                    <h4>Agregar Alergia:</h4>
                                    <h4><b>{nameAlergie.toUpperCase()}</b></h4>
                                </div>
                        }
                        {/* <div>
                            <MedicalCheckbox
                                defaultChecked={false}
                                onChange={(event, check) => {
                                    handlerCheckIsValid(check);
                                }}
                                iconStyle={{ fill: 'green' }} />
                        </div> */}
                    </div>
                </Row>
                <Row>
                    <Col md={6}>
                        {/* <TextField
                            label="Nombre"
                            value={nameAlergie}
                            onChange={(event) => {
                                setNameAlergie(event.target.value)
                            }}
                            type="text"
                            className="medical-material-form__field"
                            error={errors.hasOwnProperty("nombre") ? errors.nombre !== "" : false}
                            helperText={errors.nombre}
                        /> */}
                        <FormControl
                            style={{ width: '100%' }}
                            error={errors.hasOwnProperty("severity") ? errors.severity !== "" : false}>
                            <InputLabel id="demo-simple-select-label">Severidad</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="id-simple-select"
                                defaultValue={null}
                                value={severity}
                                onChange={(event) => {
                                    setSeverity(event.target.value)
                                }}
                                error={errors.hasOwnProperty("severity") ? errors.severity !== "" : false}
                            >
                                <MenuItem key={1} value={'1'}>Muy leve</MenuItem>
                                <MenuItem key={2} value={'2'}>Leve</MenuItem>
                                <MenuItem key={3} value={'3'}>Moderado</MenuItem>
                                <MenuItem key={4} value={'4'}>Severo</MenuItem>
                            </Select>
                            <FormHelperText>{errors.severity}</FormHelperText>
                        </FormControl>
                    </Col>
                    <Col md={6}>
                        <FormControl
                            style={{ width: '100%' }}
                            error={errors.hasOwnProperty("level") ? errors.level !== "" : false}>
                            <InputLabel id="demo-simple-select-label">Etapa de Inicio</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="id-simple-select"
                                defaultValue={null}
                                value={level}
                                onChange={(event) => {
                                    setLevel(event.target.value)
                                }}
                                error={errors.hasOwnProperty("level") ? errors.level !== "" : false}
                            >
                                <MenuItem key={1} value={'1'}>Niño</MenuItem>
                                <MenuItem key={2} value={'2'}>Adulto</MenuItem>
                                <MenuItem key={3} value={'3'}>Desconocido</MenuItem>
                            </Select>
                            <FormHelperText>{errors.level}</FormHelperText>
                        </FormControl>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <TextField
                            label="Reacciones"
                            value={reaction}
                            onChange={(event) => {
                                setReaction(event.target.value);
                            }}
                            type="text"
                            className="medical-material-form__field"
                        /* error={errors.hasOwnProperty("nombre") ? errors.nombre !== "" : false}
                        helperText={errors.nombre} */
                        />
                    </Col>
                    <Col md={6}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <ThemeProvider theme={defaultMaterialTheme}>
                                <KeyboardDatePicker
                                    disableFuture
                                    label="Fecha de Inicio"
                                    value={alergieDate}
                                    onChange={(date) => {
                                        if (date !== null) {
                                            if (date._isValid) {
                                                setAlergieDate(new Date(date))
                                            }
                                        }
                                    }}
                                    animateYearScrolling
                                    format="DD/MM/YYYY"
                                    autoOk={true}
                                    style={{ width: '100%' }}
                                />
                            </ThemeProvider>
                        </MuiPickersUtilsProvider>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            label="Comentario"
                            value={comment}
                            onChange={(event) => {
                                setComment(event.target.value)
                            }}
                            type="text"
                            className="medical-material-form__field"
                            error={errors.hasOwnProperty("comment") ? errors.comment !== "" : false}
                            helperText={errors.comment}
                        />
                    </Col>
                </Row>
                <Row>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', margin: '0.5em 0.5em' }}>
                        <div>
                            <Button
                                size="sm"
                                color="primary"
                                onClick={() => {
                                    onToggleToClose()
                                }}
                            >
                                Cerrar
                            </Button>
                        </div>
                        <div>
                            <Button
                                size="sm"
                                color="primary"
                                style={{ marginLeft: '0.5em' }}
                                onClick={() => {
                                    if (editAlergie && alergieToForm !== null){
                                        EditAlergie(alergieToForm.id_alergia);
                                    }else {
                                        saveAlergie();
                                    }
                                }}
                            >
                               {editAlergie ? 'Editar' : 'Guardar' } 
                            </Button>
                        </div>
                    </div>
                </Row>
            </div>
            {
                openAlert ?
                    <ModalUI
                        color={modalAlert.color}
                        title={modalAlert.title}
                        message={modalAlert.message}
                        modal={openAlert}
                        toggle={() => { setOpenAlert(!openAlert) }}
                        onOk={() => { setOpenAlert(!openAlert) }}
                    /> : null}
        </Fragment>
    )
}

export default FormAddAlergie